import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=a9d78012&scoped=true&"
var script = {}
import style0 from "./Service.vue?vue&type=style&index=0&id=a9d78012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d78012",
  null
  
)

export default component.exports